<template>
    <div>
        <Form @submit.prevent="authenticate()">
            <b-row v-if="screen === 'token'" form>
                <div class="wd-100p d-flex flex-column flex-sm-row mg-b-10">
                    <input type="text" minlength="6" maxlength="6" v-model="model.token" class="form-control wd-sm-250 flex-fill" placeholder="Enter token">
                    <base-button
                            class="mt-0 ml-2"
                            :loading="auth.authLoading"
                            title="Authenticate"
                    ></base-button>
                </div>
            </b-row>

            <b-row v-if="screen === 'otp'" form>
                <div class="wd-100p d-flex flex-column flex-sm-row mg-b-10">
                    <input type="text" minlength="6" maxlength="6" v-model="model.token" class="form-control wd-sm-250 flex-fill" placeholder="Enter token">
                    <base-button
                            class="mt-0 ml-2"
                            :loading="auth.authLoading"
                            title="Authenticate"
                    ></base-button>
                </div>
            </b-row>
        </Form>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import BaseButton from "../button/BaseButton";
    export default {
        name: "ForgotForm",
        components:{BaseButton},
        data() {
            return {
                screen:'token',
                model: {
                    token: ''
                },
            }
        },
        methods: {
            async authenticate() {
                this.model.dialogs = this.$dialogs
                await this.$store.dispatch("auth/authorize2fa", this.model, {root: false})

                //this.model.uniqueref = this.auth.response.uniqueref
            },
        },
        computed:{
            ...mapState([
                'company',
                'document',
                'system',
                'auth',
                'officer',
            ]),
        },
    }
</script>

<style scoped>

</style>